import React from "react";
import {
  Box,
  Button,
  Grid,
  Select,
  Switch,
  useState,
  useEffect,
  useLocation,
  useCallback,
  GetCookie,
  toast,
  swal,
} from "../../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index";
import Refreshicon from "../../../Assets/svgs/Refreshicon.svg";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import MediaContent from "../../../components/MediaScreen/MediaContent";
import FooterContent from "../../../components/MediaScreen/FooterContent";
import SidebarContent from "../../../components/MediaScreen/SidebarContent";
import LogoContent from "../../../components/MediaScreen/LogoContent";
import { useSelector, useDispatch } from "react-redux";
import SelectedLayout from "../../../components/MediaScreen/SelectedLayout";

import { Dialog } from "primereact/dialog";
import { LayoutSelection } from "../../../Libraries/Post/AddNewPost/Parent/index";
import SettingContent from "../../../components/EditPost/SettingOptions/SettingsContent";
import { setMedia, setTempSelectedLayout, setLayoutData } from "../../../Redux/slices/slices";

import {
  useUpdateLayoutMutation,
  useGetScreenLayoutMutation,
  useGetSingleScreenDetailsMutation,
  useRefreshScreenMutation,
} from "../../../Redux/service/AllEmpData";

export default function ScreenMediaData() {
  const location = useLocation();
  const [loadingScreenData, setLoadingScreenData] = useState(false);
  const [loadingMedia, setLoadingMedia] = useState(false);
  const [loadingLayout, setLoadingLayout] = useState(false);
  const [refreshingScreen, setRefreshingScreen] = useState(false);
  const [value, setValue] = useState(0);
  const [zone, setZone] = useState(1);
  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();

  // Redux state
  // const media = useSelector((state) => state.screen.media);
  const tempSelectedLayout = useSelector((state) => state.screen.tempSelectedLayout);
  const layoutdata = useSelector((state) => state.screen.layoutData);
  const currentScreenId = location?.state;
  const [refreshscreen] = useRefreshScreenMutation();
  const [currentScreen, setCurrentScreen] = useState([]);
  const [getSingleScreenDetails] = useGetSingleScreenDetailsMutation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeScreenId, setActiveScreenId] = useState(null);
  const [opendialog, setOpenDialog] = useState(false);
  const [getScreenLayoutFromDB] = useGetScreenLayoutMutation();
  const [updateLayout] = useUpdateLayoutMutation();
  const handleChange = (_, newValue) => setValue(newValue);
  const showDialog = () => {
    dispatch(setTempSelectedLayout(layoutdata));
    setOpenDialog(true);
  };
  const hideDialog = () => setOpenDialog(false);
  const handleChangeSelectedLayout = (layoutId) => {
    dispatch(setTempSelectedLayout(layoutId));
  };
  const getScreenLayout = useCallback(async () => {
    if (!currentScreenId?.[0]?.value) return;

    try {
      const formData = new FormData();
      formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
      formData.append("security_token", await GetCookie("es_token"));
      formData.append("ser_screen_id", currentScreenId[0].value);

      const res = await getScreenLayoutFromDB(formData).unwrap();

      if (res.status === "true") {
        // setLayoutData(res.layout_id);
        dispatch(setLayoutData(res.layout_id));
      } else {
        toast.error(res.message || "Failed to fetch layout");
      }
    } catch {
      toast.error("Layout fetch failed");
    }
  }, [currentScreenId, getScreenLayoutFromDB]);

  const handleSaveLayout = async () => {
    if (!tempSelectedLayout) {
      toast.error("Please select a layout");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
      formData.append("security_token", await GetCookie("es_token"));
      formData.append("ser_screen_id", currentScreenId[0].value);
      formData.append("ser_layout_id", tempSelectedLayout);

      const res = await updateLayout(formData).unwrap();

      if (res.status === "true") {
        toast.success(res.message);
        dispatch(setLayoutData(tempSelectedLayout)); 
        hideDialog();
      } else {
        toast.error(res.message);
      }
    } catch {
      toast.error("Update failed");
    }
  };
  const getSingleScreenData = async () => {
      setLoadingScreenData(true);
      try {
        const formData = new FormData();
        formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
        formData.append("security_token", await GetCookie("es_token"));
        formData.append("ser_screen_id", currentScreenId[0].value);

        const res = await getSingleScreenDetails(formData).unwrap();
        if (res.status === "true") {
          setCurrentScreen(res.data);
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error("Failed to fetch screen data");
      } finally {
        setLoadingScreenData(false);
      }
    };

  const handleRefreshScreen = async () => {
    setRefreshingScreen(true);
    try {
      const payload = new FormData();
      payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("ser_screen_id", currentScreenId[0].value);

      const res = await refreshscreen(payload).unwrap();
      if (res.connection === "true" && res.status === "true") {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to refresh screen");
    } finally {
      setRefreshingScreen(false);
    }
  };
  useEffect(() => {
    getScreenLayout();
    getSingleScreenData();
  }, [getScreenLayout]);
  useEffect(() => {
  if (value === 1) {
    getSingleScreenData();
  }
}, [value]);
  
  return (
    <Box sx={{ flexGrow: 1, mr: 3, mt: 1 }}>
      {/* Header */}
      <Box className="d-flex bg-white px-3 py-3 justify-content-between">
        <div>
          <h3>{currentScreen.txt_screen_name}</h3>
          <span>Last updated {currentScreen.dte_updated_date}</span>
        </div>
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <Button
        startIcon={
            <img
              src={Refreshicon}
              alt="plus"
              className="refresh-icon"
              style={{
                width: "18px",
                height: "18px",
                objectFit: "contain",
                transition: "0.3s ease",
              }}
            />
          }
          variant="contained"
          sx={{ 
            background: "#1A75E829", 
            color: "#1A75E8" , 
            "&:hover": {
              backgroundColor: "#1A75E8",
              color: "#ffffff",
              boxShadow: "none",
              },
              "&:hover .refresh-icon": {
                filter: "brightness(0) invert(1)",
                },
            }}
          className= "capitalized"
          onClick={() => handleRefreshScreen()}
        >
          {/* <span className= "capitalized" style={{fontWeight: "600"}}> */}
            Refresh
            {/* </span> */}
        </Button>
        </Box>
      </Box>

      {/* Body */}
      <Box className="d-flex py-4 gap-3" >
        {/* Left Panel */}
        <Box sx={{ width: "25%", borderRadius: '16px' }} className="bg-white p-3">
          <Tabs value={value} onChange={handleChange} variant="fullWidth">
            <Tab label="Layout" />
            <Tab label="Settings" />
          </Tabs>

          {value === 0 && (
           <Box sx={{ mt: 3 }}>
            <Box className="flex flex-column px-3 py-4 gap-3 mt-2" sx={{background: '#F4F6F8', borderRadius: '16px'}} >
            <Box component={'span'} sx={{fontSize: '16px', fontWeight: '600' , color:'#000000AB'}}>Layout {layoutdata}</Box>
            <Chip label={`Zone${zone}`} className="px-0 py-0" sx={{fontSize: '14px' ,background:'#1A75E829' , color: '#1A75E8', borderRadius: '4px', width:'30%',  flexShrink: 0,}}/>
            
            <Box sx={{ mb: 2 }}>
                <SelectedLayout layout={layoutdata} onZoneChange={setZone} />
            </Box>

            <Button
                size="small"
                fullWidth
                onClick={showDialog}
                sx={{
                  backgroundColor: "#1a75e8",
                  color: "#fff",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 500,
                  textTransform: "capitalize"
                }}
            >
                Edit Layout
            </Button>
            </Box>
            </Box>
          )}

          {value === 1 && <SettingContent currentScreen={currentScreen} layout={layoutdata} onScreenUpdate={async (newLayoutId) => {await getSingleScreenData(); if (newLayoutId) dispatch(setLayoutData(newLayoutId)); setZone(newLayoutId); }}/>}
        </Box>

        {/* Right Panel */}
        <Box sx={{ width: "75%" }}>
          {zone === 1 && <MediaContent  currentScreen={currentScreen}/>}
          {zone === 2 && <FooterContent currentScreen={currentScreen} />}
          {zone === 3 && <SidebarContent currentScreen={currentScreen} />}
          {zone === 4 && <LogoContent currentScreen={currentScreen}/>}
        </Box>
      </Box>

      {/* Layout Dialog */}
      <Dialog
        visible={opendialog}
        onHide={hideDialog}
        header="Select Layout"
        modal
        style={{ width: "1200px" }}
      >
        <Box className="flex justify-center">
        <LayoutSelection
          data={{ selectedLayout: tempSelectedLayout }}
          handleChangeSelectedLayout={handleChangeSelectedLayout}
          currentScreen = {currentScreen}
          className= "layouttab"
        />
        </Box>

        <Box sx={{ textAlign: "right", mt: 3 }}>
          <Button variant="contained" onClick={handleSaveLayout}>
            Save
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
}
